<template>
  <div class="v-header">
    <nav class="navbar navbar-expand navbar-light border-bottom">
      <div class="container">
        <router-link to="/">
          <a class="navbar-brand" href="#"><strong>PaySim</strong></a>
        </router-link>
        <ul class="navbar-nav ml-auto" id="main-navbar" v-if="isAuthenticated">
          <li class="nav-item">
            <router-link class="page-link" to="/account">Настройки</router-link>
          </li>
          <li class="nav-item">
            <a class="page-link" @click="logout">Выход</a>
          </li>
        </ul>
        <ul class="navbar-nav ml-auto" v-else>
          <li class="nav-item text-muted">
            <font-awesome-icon :icon="['fas', 'lock']" />
            <small class="pl-2">SSL Secure</small>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'v-header',
  methods: {
    logout() {
      this.$store.dispatch('auth/logout')
        .then(() => this.$router.go(0));
    },
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated']),
  },
};
</script>
